export const WORKFLOW_DECLINE_TYPES = {
  RETURN: "RETURN",
  REJECT: "REJECT",
} as const;

export const WORKFLOW_DECLINE_TYPES_KEYS = Object.keys(WORKFLOW_DECLINE_TYPES);
export type WorkflowDeclineType = keyof typeof WORKFLOW_DECLINE_TYPES;
